import * as React from "react"

export const useSessionStorage = (storageName: string) => {
  const storage = sessionStorage.getItem(storageName)
  const parseStorageData = JSON.parse(sessionStorage.getItem(storageName))

  React.useEffect(() => {
    if (!storage) {
      sessionStorage.setItem(storageName, JSON.stringify({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setSessionStorage = React.useCallback(
    (data, variant: "rewrite" | "add") => {
      if (variant === "add") {
        let history = {}
        if (storage) {
          history = JSON.parse(storage)
        }
        history = Object.assign(history, data)
        sessionStorage.setItem(storageName, JSON.stringify(history))
      }

      if (variant === "rewrite") {
        sessionStorage.setItem(storageName, JSON.stringify(data))
      }
    },
    [storage, storageName]
  )

  const removeStorage = () => {
    localStorage.removeItem(storageName)
  }
  return { storage, setSessionStorage, parseStorageData, removeStorage }
}
